import { LoginComponent } from './login.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '@shared';

@NgModule({
	imports: [CommonModule, FormsModule, IonicModule, ReactiveFormsModule, TranslateModule, SharedModule],
	declarations: [LoginComponent]
})
export class LoginPageModule {}
